<div class="sidenav p-4">
  <button
    (click)="onReferNewCase()"
    class="bg-sky-600 hover:bg-sky-700 text-white font-bold py-2.5 px-5 rounded-lg shadow-sm cursor-pointer whitespace-nowrap w-full mb-4"
    data-cy="page-home-button-newCase"
  >
    New Case
  </button>
  <ul class="space-y-2">
    <li>
      <a
        (click)="onAllCasesClick()"
        [ngClass]="{
          'bg-sky-100 dark:bg-sky-800 text-sky-700 dark:text-sky-200 font-bold': activeFilter()?.filterValue === '',
          'text-gray-600 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700':
            activeFilter()?.filterValue !== ''
        }"
        class="flex items-center justify-between px-3 py-2 rounded-lg text-sm cursor-pointer"
        data-cy="page-allCases-tab-all"
      >
        <span class="flex items-center gap-2">
          <span class="material-symbols-outlined text-base dark:text-gray-200">list</span>
          All Cases
        </span>
      </a>
    </li>
    @for (metric of metrics(); track metric.filterValue) {
    <li>
      <a
        (click)="metric.count > 0 && onFilterClick(metric)"
        [ngClass]="{
          'bg-sky-100 dark:bg-sky-800 text-sky-700 dark:text-sky-200 font-bold':
            activeFilter()?.filterValue === metric.filterValue,
          'text-gray-600 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700':
            activeFilter()?.filterValue !== metric.filterValue && metric.count > 0,
          'text-gray-400 dark:text-gray-500 cursor-not-allowed': metric.count === 0
        }"
        class="flex items-center justify-between px-3 py-2 rounded-lg text-sm cursor-pointer"
        [attr.data-cy]="'page-allCases-tab-' + (metric.filterValue === 'pending' ? 'submitted' : metric.filterValue | lowercase)"
      >
        <span class="flex items-center gap-2">
          @if (metric.icon) {
          <span class="material-symbols-outlined text-base dark:text-gray-200">{{ metric.icon }}</span>
          }
          {{ metric.title }}
        </span>
        <span
          [ngClass]="{
            'bg-gray-200 dark:bg-gray-600 text-gray-800 dark:text-gray-200': metric.count > 0,
            'bg-gray-100 dark:bg-gray-700 text-gray-400 dark:text-gray-500': metric.count === 0
          }"
          class="px-2 py-0.5 rounded-full text-xs font-medium"
          >{{ metric.count }}</span
        >
      </a>
    </li>
    }
  </ul>
</div>
